module.exports = "<div class=modal-header> <h4 class=\"modal-title text-left\" id=myModalLabel>Just making sure!</h4> </div> <div class=modal-body> <fieldset> {{$ctrl.resolve.body}} </fieldset> </div> <div class=modal-footer> <button type=button class=\"btn btn-default\" data-dismiss=modal ng-click=$ctrl.dismissModal()>No</button> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.yes()>Yes</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/settings/alertpopup/alertpopup.html
// module id = 505
// module chunks = 0